import type { ChartType } from '@lighthouse/core'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { CompositeDesign } from './DesignConfiguratorRender/CompositeDesign'
import type { ChartFormSlice } from './formSlice'

export const Design: React.FC = () => {
    const { watch } = useFormContext<ChartFormSlice>()
    const chartType = (watch('chartType') ?? 'bar') as ChartType
    return useMemo(() => {
        switch (chartType) {
            case 'composite':
            case 'pie':
            case 'bar':
            case 'funnel':
            case 'striation':
            case 'line':
            case 'radar': {
                return <CompositeDesign chartType={chartType} />
            }
            default: {
                return null
            }
        }
    }, [chartType])
}
